module.exports = __webpack_public_path__ + "img/avatar-leia.b62ec947.png";